import Box from '@mui/material/Box'

export const LicenseUpdatesParameterCell = ({ value }: { value: unknown }) => {
	if (typeof value === 'string') {
		return (
			<Box mt={1}>
				Preset: &nbsp;
				<Box component="span" sx={{ color: '#4B6687' }}>
					{value}
				</Box>
			</Box>
		)
	}

	if (Array.isArray(value)) {
		return (
			<>
				{value.map((row: Array<[string, string]>, i) => (
					<Box key={i} mt={1}>
						<Box component="span">{row?.[0]}</Box>
						&nbsp;-&nbsp;
						<Box component="span" sx={{ color: '#4B6687' }}>
							{row?.[1]}
						</Box>
					</Box>
				))}
			</>
		)
	}

	return <></>
}